// extracted by mini-css-extract-plugin
export default {"heading":"Startpage_heading__xE-Pi","content":"Startpage_content__6oNsA","introPicture":"Startpage_introPicture__zpReb","container":"Startpage_container__n3+TX"};